// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".k-tour-get-started[data-v-11e770b6]{position:relative;overflow:hidden}@media screen and (min-width:960px){.k-tour-get-started .title--regular[data-v-11e770b6]{font-size:36px!important}}.k-tour-get-started__img[data-v-11e770b6]{position:absolute;bottom:-10px;right:0;width:50%!important}@media screen and (max-width:959px){.k-tour-get-started__img[data-v-11e770b6]{bottom:-60px}}", ""]);
// Exports
module.exports = exports;
